import http from "../../helpers/http";
import { doObjToFormData } from "../../helpers/helpers";

// POST /api/validate-coupon
//
// Body (form-data):
//   token        — referrer auth (current user)
//   coupon_code  — the code to validate
//   plan_id      — plan being purchased (so backend can scope the discount)
//
// Expected success response:
//   {
//     status: 1,
//     coupon_code: "SAVE50",
//     original_price: 249,
//     discount_value: 50,          // dollars saved (number)
//     discount_label: "$50 off",   // display string ("$50 off" or "10% off")
//     total_after_discount: 199,
//     msg: "Coupon applied"
//   }
//
// Expected error responses (status: 0):
//   { status: 0, code: "invalid_coupon",  msg: "That code isn't valid." }
//   { status: 0, code: "coupon_expired",  msg: "This code has expired." }
//   { status: 0, code: "coupon_not_for_plan", msg: "Not valid for this plan." }
//   { status: 0, code: "coupon_used",     msg: "You've already used this code." }
//
// Backend responsibility (out of scope for the frontend):
//   - Validate code exists, hasn't expired, applies to this plan
//   - Calculate dollar discount from percent/fixed scheme
//   - Return total_after_discount = original_price - discount_value
//   - Re-validate on /create-payment-intent (this preview endpoint is
//     advisory; the authoritative check happens at charge time)

export const validateCoupon = (formData) => () =>
  http
    .post(
      "validate-coupon",
      doObjToFormData({
        token: localStorage.getItem("authToken"),
        ...formData,
      })
    )
    .then(({ data }) => data);
